import * as React from 'react'
import { Button, Form, Table } from 'react-bootstrap'
import IosWarning from 'react-ionicons/lib/IosWarning'
import { useSelector } from 'react-redux'
import Select from 'react-select'
//import "react-select/dist/react-select.css"
import * as _ from 'lodash'
import { IAppState } from '../../redux/reducers'


interface CommunicationsProps {

}

const Communications : React.FunctionComponent<CommunicationsProps> = ({}) : JSX.Element => {
    let auth = useSelector((state:IAppState) => state.auth)
    const userRole = auth && auth.userData &&  _.isArray(auth.userData.roles) && auth.userData.roles[0]

    const [commTypeFilterValue, setCommTypeFilterValue] = React.useState('')

    const filterOptions = [
        { value: 'damage', label: 'Damage' },
        { value: 'infraction', label: 'Infraction' },
        { value: 'notes', label: 'Notes' },
        { value: 'rating', label: 'Rating' }
    ]

    const renderFilter = () : JSX.Element => {
        return (
            <div>
                <h3>Communications Filter</h3>
                <Form.Label>Type Filter</Form.Label>
                <Select
                    className="input-material"
                    multi
                    onChange={(e) => {setCommTypeFilterValue(e.value)}}
                    options={filterOptions}
                    value={commTypeFilterValue} />
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                    <span>
                        <Form.Label>Start Date Filter</Form.Label>
                        <Form.Control className="input-material" />
                    </span>
                    <span>
                        <Form.Label>End Date Filter</Form.Label>
                        <Form.Control className="input-material" />
                    </span>
                </div>
                <Button>Save Filter</Button>
            </div>
        )
    }

    return (
        <div>
            {renderFilter()}
            <h3>Communications</h3>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Job</th>
                        <th>Type</th>
                        <th>Rating</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Oct. 31, 2020</td>
                        <td>Intrastate Local Moving for Andrea Prices</td>
                        <td><IosWarning color="red" /><IosWarning color="red" /><IosWarning color="red" /></td>
                        <td>78%</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default Communications